export default __webpack_public_path__ + "static/media/otp.5d7a528e.png";